import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ISecurityEventInfo,
  ISecurityEventsGridItem,
  ISecurityEventPrefill,
  ISecurityEventUpdate,
} from '../interfaces/security-events.interface';
import { Observable, share } from 'rxjs';
import { environment } from '@env/environment';
import { IInitiatingEventPrefillRequest } from '@core/interfaces/initiating-event.interface';
import type {
  IGridRequestBody,
  IGridResponseBody,
} from 'ngx-mt-ui-lib/interfaces';

@Injectable({ providedIn: 'root' })
export class SecurityEventsApiService {
  private readonly httpClient = inject(HttpClient);

  public getGrid(
    body: IGridRequestBody,
  ): Observable<IGridResponseBody<ISecurityEventsGridItem>> {
    return this.httpClient
      .post<
        IGridResponseBody<ISecurityEventsGridItem>
      >(`${environment.API_URL}/dispatching/security-event/grid`, body)
      .pipe(share());
  }

  public update(
    id: number,
    body: ISecurityEventUpdate,
  ): Observable<ISecurityEventInfo> {
    return this.httpClient
      .put<ISecurityEventInfo>(
        `${environment.API_URL}/dispatching/security-event/${id}`,
        body,
      )
      .pipe(share());
  }

  public getInfo(id: number): Observable<ISecurityEventInfo> {
    return this.httpClient.get<ISecurityEventInfo>(
      `${environment.API_URL}/dispatching/security-event/${id}/info`,
    );
  }

  public prefill(
    body: IInitiatingEventPrefillRequest,
  ): Observable<ISecurityEventPrefill> {
    return this.httpClient.post<ISecurityEventPrefill>(
      `${environment.API_URL}/dispatching/security-event/prefill`,
      body,
    );
  }

  public setToWorking(id: number): Observable<unknown> {
    return this.httpClient.get(
      `${environment.API_URL}/dispatching/security-event/${id}/working`,
    );
  }

  public setToCompleted(id: number): Observable<unknown> {
    return this.httpClient.get(
      `${environment.API_URL}/dispatching/security-event/${id}/completed`,
    );
  }

  public setToClose(id: number): Observable<unknown> {
    return this.httpClient.get(
      `${environment.API_URL}/dispatching/security-event/${id}/close`,
    );
  }

  public setToCancel(id: number, reason: string): Observable<unknown> {
    return this.httpClient.post(
      `${environment.API_URL}/dispatching/security-event/${id}/cancel`,
      { reason },
    );
  }

  public setToArchive(id: number): Observable<unknown> {
    return this.httpClient.get(
      `${environment.API_URL}/dispatching/security-event/${id}/archive`,
    );
  }
}
